import { SET_OTP } from '../actions/types';

const initialState = {
  items: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_OTP: {
      const { id, ...rest } = action.payload;
      state.items[id] = { ...state.items[id], ...rest };
      return state;
    }

    default:
      return state;
  }
};

export { reducer as otp };
